import CourseContentLayoutInstructor from "./CourseContentLayoutInstructor";

function SeniorCourse(props) {
  return <CourseContentLayoutInstructor {...props} totalModules={6} />;
}

export default SeniorCourse;